import React, { useRef } from 'react'
import { Button, Form } from 'semantic-ui-react'
import useAxios from 'hooks/useAxios'
import { toast } from 'libs/toast'
import uuid from 'uuid/v4'
import useSaveUserActivityLog, { ANSWER_TOPIC_ACTION_NAME } from 'hooks/useSaveUserActivityLog'
import useUser from 'hooks/useUser'
import * as R from 'ramda'

const CreateUpdateTopiGroupcModal = ({
  modal: Modal,
  isOpenTopicGroupModal,
  close,
  editingTopicGroup,
  setEditingTopicGroup,
  setTopicGroupState,
  topicGroupData,
}) => {
  const hiddenRefButton = useRef(null)

  const userInfo = useUser()
  const companyId = R.path(['selected_workspace', 'id'], userInfo)

  const saveUserActivityLog = useSaveUserActivityLog()
  const { fetch: createTopicGroup, loading: isCreatingTopicGroup } = useAxios({
    method: 'post',
    url: 'responses/topic-groups/',
    skip: true,
  })

  const { fetch: updateTopicGroup, loading: isUpdatingTopicGroup } = useAxios({
    method: 'patch',
    url: `responses/topic-groups/${editingTopicGroup.id}/`,
    skip: true,
  })

  function handleSubmit() {
    if (editingTopicGroup.id) {
      handleUpdateTopicGroup()
    } else {
      handleCreateTopicGroup()
    }
  }

  function handleCreateTopicGroup() {
    const existedTopicGroups = topicGroupData
    const isDuplicate = existedTopicGroups.some(
      (group) => group.name.toLowerCase() === editingTopicGroup.name.toLowerCase()
    )

    if (isDuplicate) {
      toast.error('The group you are trying to create already exists.')
      return
    }

    const data = {
      name: editingTopicGroup.name,
    }

    createTopicGroup({ data })
      .then((res) => {
        if (res.data) {
          toast.success('New topic group created!')
          setTopicGroupState((prev) => {
            return [...prev, { ...res.data, key: uuid() }]
          })
          saveUserActivityLog({
            action: ANSWER_TOPIC_ACTION_NAME.create_new_topic_group,
            statusCode: res.status,
            requestBody: data,
            target: `com_${companyId}`,
          })

          close()
        }
      })
      .catch((err) => {
        saveUserActivityLog({
          action: ANSWER_TOPIC_ACTION_NAME.create_new_topic_group,
          statusCode: err.response.status,
          errorResponseBody: err.response.data,
          requestBody: data,
          target: `com_${companyId}`,
        })
        toast.error(
          'Uh oh. There was a problem creating the new topic group. Please try again or contact Simplesat support.'
        )
        console.error(err)
      })
  }

  function handleUpdateTopicGroup() {
    const existedTopicGroups = topicGroupData
    const isNameChanged = editingTopicGroup.name === editingTopicGroup.original_name
    const isDuplicate = existedTopicGroups.some(
      (group) => group.name.toLowerCase() === editingTopicGroup.name.toLowerCase()
    )

    if (!isNameChanged && isDuplicate) {
      toast.error('The group you are trying to update already exists.')
      return
    }

    const data = {
      name: editingTopicGroup.name,
    }
    updateTopicGroup({ data })
      .then((res) => {
        if (res.data) {
          toast.success('Topic group updated!')
          setTopicGroupState((prev) => {
            const filteredResults = prev.map((group) =>
              group.key === editingTopicGroup.key ? { ...res.data, key: uuid() } : group
            )

            return filteredResults
          })

          saveUserActivityLog({
            action: ANSWER_TOPIC_ACTION_NAME.edit_topic_group,
            statusCode: res.status,
            requestBody: data,
            target: `topic_group_${editingTopicGroup.id}`,
          })

          close()
        }
      })
      .catch((err) => {
        saveUserActivityLog({
          action: ANSWER_TOPIC_ACTION_NAME.edit_topic_group,
          statusCode: err.response.status,
          errorResponseBody: err.response.data,
          requestBody: data,
          target: `topic_group_${editingTopicGroup.id}`,
        })
        toast.error(
          'Uh oh. There was a problem updating the new topic group. Please try again or contact Simplesat support.'
        )
        console.error(err)
      })
  }

  return (
    <Modal open={isOpenTopicGroupModal} onClose={close} size="small">
      <Modal.Header>
        {editingTopicGroup.id ? 'Edit topic group' : 'Create new topic group'}
      </Modal.Header>
      <Modal.Content>
        <Form onSubmit={handleSubmit}>
          <Form.Field>
            <label>Topic group name</label>
            <input
              required
              value={editingTopicGroup.name}
              onChange={(e) => setEditingTopicGroup({ ...editingTopicGroup, name: e.target.value })}
              maxLength={200}
            />
          </Form.Field>
          <input type="submit" hidden ref={hiddenRefButton} />
        </Form>
      </Modal.Content>
      <Modal.Actions>
        <Button onClick={close}>Cancel</Button>
        <Button
          onClick={() => hiddenRefButton.current.click()}
          disabled={isCreatingTopicGroup || isUpdatingTopicGroup}
          loading={isCreatingTopicGroup || isUpdatingTopicGroup}
          primary
        >
          {editingTopicGroup.id ? 'Save' : 'Create topic group'}
        </Button>
      </Modal.Actions>
    </Modal>
  )
}

export default CreateUpdateTopiGroupcModal



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/pages/Admin/Topics/TopicGroupModal.js